import { useEffect, useState } from "react";
import { DoctorCard } from "../components/DoctorCard";
import { useLang } from "../context/LanguageContext";
import { api } from "../lib/api";

export default function Doctors() {
  const { t } = useLang();
  const [doctors, setDoctors] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/doctors").then((r) => setDoctors(r.data)).catch(() => {});
  }, []);

  const specs = [...new Set(doctors.map((d) => d.specialization))];
  const shown = filter === "all" ? doctors : doctors.filter((d) => d.specialization === filter);

  return (
    <div data-testid="doctors-page" className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
      <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 mb-4">{t("doctors.title")}</h1>
      <p className="text-base md:text-lg text-slate-500 mb-10 max-w-2xl">{t("doctors.subtitle")}</p>
      <div className="flex flex-wrap gap-2 mb-10">
        <button onClick={() => setFilter("all")} data-testid="doctor-filter-all"
          className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${filter === "all" ? "bg-primary text-white border-primary" : "border-slate-200 text-slate-600 hover:border-primary"}`}>
          All
        </button>
        {specs.map((s) => (
          <button key={s} onClick={() => setFilter(s)} data-testid={`doctor-filter-${s.replace(/\s+/g, "-").toLowerCase()}`}
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${filter === s ? "bg-primary text-white border-primary" : "border-slate-200 text-slate-600 hover:border-primary"}`}>
            {s}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {shown.map((d) => <DoctorCard key={d.id} doctor={d} />)}
      </div>
    </div>
  );
}
